import { Box } from '@mui/material';
import React from 'react';
type Props = {
  children: React.ReactNode;
};
export default function OhsModuleListBackground(props: Props) {
  return <Box pt={2}>{props.children}</Box>;
}
